import { Component } from "@angular/core";

@Component({
    selector: "app-resources-page",
    templateUrl: "./resources-page.component.html",
    standalone: false
})
export class ResourcesPageComponent {}
